// import { Link } from "react-router-dom";
// import PageBanner from "../PageBanner";
// import SocialMediaSidebar from "../SocialMediaSidebar";
// import SectionHeader from "../SectionHeader";

// const Videos = () => {
//   const videos = [
//     {
//       id: 1,
//       title: "SMART BINS",
//       src: "https://www.youtube.com/embed/OljMz6loCvI",
//       bgColor: "bg-[#84ecc6]",
//     },
//     {
//       id: 2,
//       title: "SMART SOLID WASTE MANAGEMENT",
//       src: "https://www.youtube.com/embed/tArwofKm_Gc",
//       bgColor: "bg-[#84ecc6]",
//     },
//     {
//       id: 3,
//       title: "AJEEVI VEHICLE TRACKING APP",
//       src: "https://www.youtube.com/embed/-tUFbAwQij8",
//       bgColor: "bg-[#84ecc6]",
//     },
//     {
//       id: 4,
//       title: "RFID TAGS-Video",
//       src: "https://www.youtube.com/embed/yvoOzaeMCm4",
//       bgColor: "bg-[#84ecc6]",
//     },
//     {
//       id: 5,
//       title: "RFID TAGS PART I",
//       src: "https://www.youtube.com/embed/BIJsaRE6hlE",
//       bgColor: "bg-[#84ecc6]",
//     },
//     {
//       id: 6,
//       title: "RFID TAGS PART II",
//       src: "https://www.youtube.com/embed/HBpHs0zaYkI",
//       bgColor: "bg-[#84ecc6]",
//     },
//     {
//       id: 7,
//       title: "AUTOMATED WASTE COLLECTION",
//       src: "https://www.youtube.com/embed/2hUVZqHBaF4",
//       bgColor: "bg-[#84ecc6]",
//     },
//   ];

//   return (
//     <>
//       <div>
//         <SocialMediaSidebar />
//       </div>
//       <PageBanner
//         title="Videos"
//         breadcrumb={[
//           { label: "Home", href: "/" },
//           { label: "Resources" },
//           { label: "Videos" },
//         ]}
//       />
//       <div className="max-w-6xl mx-auto p-4">
//         <SectionHeader
//           title="Videos @ AJEEVI"
//           shareUrl="https://swmecom.ajeevi.in/videos"
//         />
//       </div>

//       {/* Page content */}
//       <div className="bg-white w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 text-gray-800">
//         {/* Header */}
//         <div className="text-center mb-10">
//           <h2 className="text-[#00D084] text-3xl font-bold mb-4">
//             Transforming Waste Management with Ajeevi's Smart Solutions
//           </h2>
//           <p className="text-xl">
//             Real-time tracking, intelligent routing, and connected
//             infrastructure driving cleaner, smarter cities across India.
//           </p>
//         </div>

//         {/* Video Grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//           {videos.map((video) => (
//             <div key={video.id} className="flex flex-col h-full">
//               <div className="card border border-gray-200 shadow-sm  overflow-hidden h-full flex flex-col">
//                 {/* Video Embed */}
//                 <div className="aspect-w-16 aspect-h-9 w-full h-[230px]">
//                   <iframe
//                     src={video.src}
//                     title={video.title}
//                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                     allowFullScreen
//                     className="w-full h-full"
//                   ></iframe>
//                 </div>

//                 {/* Card Footer */}
//                 <div
//                   className={`${video.bgColor} p-4 text-center flex-grow flex items-center justify-center`}
//                 >
//                   <p className="font-bold text-gray-800 m-0">{video.title}</p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Videos;

// ====================================Above Code Works Fine===============================

import { Link } from "react-router-dom";
import PageBanner from "../PageBanner";
import SocialMediaSidebar from "../SocialMediaSidebar";
import SectionHeader from "../SectionHeader";
import React, { useState, useEffect } from "react";
import axios from "axios";

import Policy from "../../assets/images-webp/blog3.webp";
import vishal from "../../assets/images-webp/vishal.webp";

import Slider from "react-slick";
import { CMSAPI } from "../../config";
import ScrollToTopButton from "../ScrollToTopButton";
import SectionHeaderNoPDF from "../SectionHeaderNoPDF";

const Videos = () => {
  const [activeFilter, setActiveFilter] = useState("All");
  const [allVideos, setAllVideos] = useState([]); // Store ALL videos
  const [filteredVideos, setFilteredVideos] = useState([]); // Store filtered/paginated videos
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([{ name: "All", count: 0 }]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const postsPerPage = 6;

  // Fetch all videos on component mount
  useEffect(() => {
    const fetchAllVideos = async () => {
      try {
        setLoading(true);
        // Fetch all videos (using a large page size to get all data)
        const response = await axios.get(
          `${CMSAPI}/api/Video/get-videos?PageNo=1&PageSize=1000&domain=SWM`
        );

        if (response.data && response.data.data) {
          const transformedVideos = response.data.data.map((video) => ({
            img: video.photo ? `${CMSAPI}${video.photo}` : Policy,
            tag: video.category || "Sustainability",
            category: video.category || "Uncategorized",
            title: video.name || "Untitled Video",
            desc: video.about || "No description available",
            videoId: video.detail || "",
            authorImg: vishal,
            author: "Admin",
            date:
              new Date(video.regDate).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              }) || "June 9, 2025",
            slug: video.slug || `#${video.id}`,
          }));

          setAllVideos(transformedVideos);

          // Calculate category counts
          const counts = {};
          const uniqueCategories = new Set();

          transformedVideos.forEach((video) => {
            const category = video.category || "Uncategorized";
            counts[category] = (counts[category] || 0) + 1;
            uniqueCategories.add(category);
          });

          // Define the desired category order
          const desiredOrder = [
            "Solution",
            "Software",
            "Utilities",
            "IOT",
            "AI Solutions",
            "Mobile Application",
          ];

          // Create ordered categories array
          const orderedCategories = [];

          // Add categories in the desired order
          desiredOrder.forEach((category) => {
            if (uniqueCategories.has(category)) {
              orderedCategories.push({
                name: category,
                count: counts[category] || 0,
              });
              uniqueCategories.delete(category);
            }
          });

          // Add any remaining categories that weren't in the desired order
          uniqueCategories.forEach((category) => {
            orderedCategories.push({
              name: category,
              count: counts[category] || 0,
            });
          });

          // Add "All" category at the beginning
          const dynamicCategories = [
            { name: "All", count: transformedVideos.length },
            ...orderedCategories,
          ];

          setCategories(dynamicCategories);

          // Apply initial filtering and pagination
          filterAndPaginateVideos(transformedVideos, "All", 1);
        }
      } catch (err) {
        console.error("Error fetching videos:", err);
        setError("Failed to load videos. Please try again later.");

        const fallbackVideos = [
          {
            img: Policy,
            tag: "Sustainability",
            category: "Policy",
            title: "Policy Changes in Waste Management",
            desc: "An overview of recent policy reforms in waste management sector.",
            videoId: "fdOfcUI_sWk",
            authorImg: vishal,
            author: "Admin",
            date: "June 9, 2025",
          },
        ];

        setAllVideos(fallbackVideos);
        setFilteredVideos(fallbackVideos);
        setCategories([
          { name: "All", count: fallbackVideos.length },
          { name: "Policy", count: fallbackVideos.length },
        ]);
        setTotalPages(1);
      } finally {
        setLoading(false);
      }
    };

    fetchAllVideos();
  }, []);

  // Filter and paginate videos client-side
  const filterAndPaginateVideos = (videos, filter, page) => {
    // Filter by category
    const filtered =
      filter === "All"
        ? videos
        : videos.filter((video) => video.category === filter);

    // Calculate pagination
    const totalPages = Math.ceil(filtered.length / postsPerPage);
    setTotalPages(totalPages);

    // Get videos for current page
    const startIndex = (page - 1) * postsPerPage;
    const paginatedVideos = filtered.slice(
      startIndex,
      startIndex + postsPerPage
    );

    setFilteredVideos(paginatedVideos);
  };

  // Handle filter change
  const handleFilterChange = (category) => {
    setActiveFilter(category);
    setCurrentPage(1);
    filterAndPaginateVideos(allVideos, category, 1);
  };

  // Handle page change
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    filterAndPaginateVideos(allVideos, activeFilter, pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const openVideoModal = (video) => {
    setSelectedVideo(video);
    setShowModal(true);
  };

  const closeVideoModal = () => {
    setShowModal(false);
    setSelectedVideo(null);
  };

  const truncateWords = (text, maxWords) => {
    if (!text) return "";
    const words = text.split(/\s+/).filter((word) => word.length > 0);
    return words.length > maxWords
      ? `${words.slice(0, maxWords).join(" ")}...`
      : text;
  };

  // if (loading && currentPage === 1) {
  //   return (
  //     <div className="flex justify-center items-center h-64">
  //       <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#00D084]"></div>
  //     </div>
  //   );
  // }

  if (error) {
    return <div className="text-center py-10 text-red-500">{error}</div>;
  }

  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Our Videos"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "Resources" },
          { label: "Videos" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeaderNoPDF
          title="Videos @ AJEEVI"
          shareUrl="https://swachhajv.ajeevi.in/videos"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {/* Video Modal */}
      {/* {showModal && selectedVideo && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[9999] p-4">
          <div className="bg-white rounded-lg w-full max-w-4xl relative">
            <button
              onClick={closeVideoModal}
              className="absolute -top-10 right-0 text-white text-3xl z-50"
            >
              &times;
            </button>
            <div className="relative pt-[56.25%]"> 
              <iframe
                src={`https://www.youtube.com/embed/${selectedVideo.videoId}?autoplay=1`}
                className="absolute top-0 left-0 w-full h-full rounded-t-lg"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={selectedVideo.title}
              ></iframe>
            </div>
            <div className="p-4">
              <h3 className="text-xl font-bold">{selectedVideo.title}</h3>
              <p className="text-gray-600 mt-2">{selectedVideo.desc}</p>
            </div>
          </div>
        </div>
      )} */}

      {showModal && selectedVideo && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[9999] p-2 sm:p-4">
          {/* Modal Container - Optimized for 1366×768 */}
          <div
            className="bg-white rounded-lg w-full max-w-[95vw] sm:max-w-[90vw] lg:max-w-4xl 
                    relative max-h-[85vh] sm:max-h-[90vh] overflow-hidden flex flex-col"
          >
            {/* Close Button - Optimized for 1366×768 */}
            <button
              onClick={closeVideoModal}
              className="absolute top-0 right-[-1px] z-[10000] 
                   text-gray-800 hover:text-black 
                   bg-white/90 hover:bg-white 
                   rounded-full w-9 h-9 sm:w-8 sm:h-8 
                   flex items-center justify-center 
                   shadow-lg border border-gray-200
                   transition-all duration-200
                   hover:scale-105 active:scale-95"
              aria-label="Close video"
            >
              <span className="text-3xl sm:text-4xl font-light leading-none pb-2">
                &times;
              </span>
            </button>

            {/* Video Container - Fixed height, not scrollable */}
            <div
              className="relative flex-shrink-0 bg-black"
              style={{ height: "56.25vh" }}
            >
              <iframe
                src={`https://www.youtube.com/embed/${selectedVideo.videoId}?autoplay=1`}
                className="absolute top-0 left-0 w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={selectedVideo.title}
              />
            </div>

            {/* Content Area - Scrollable on small screens */}
            <div className="flex-grow overflow-y-auto">
              <div className="p-3 sm:p-4">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">
                  {selectedVideo.title}
                </h3>
                <div className="text-sm sm:text-base text-gray-600 space-y-2">
                  {selectedVideo.desc.split("\n").map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-10 py-0 pb-5 mb-10 bg-white font-poppins">
        <h2 className="text-3xl sm:text-2xl font-medium text-[#00D084] mb-4 text-center">
          Our Video Gallery
        </h2>
        <h3 className="text-xl md:text-3xl font-medium text-gray-900 mb-2 text-center">
          Insights in SwachhAJV
        </h3>
        <p className="text-black text-base sm:text-lg max-w-3xl mx-auto mb-10 text-center">
          Explore the latest videos on sustainable practices, smart bin
          technology, AI-based waste segregation, and policy updates driving
          cleaner cities.
        </p>

        <div className="flex flex-col md:flex-row gap-8 lg:gap-2">
          {/* Left sidebar - Filters */}
          <div className="w-full md:w-1/5 lg:w-1/4">
            <div className="bg-gray-50 p-4 rounded-lg shadow-sm sticky top-4">
              <h4 className="text-lg font-semibold mb-4 text-gray-800">
                Offerings
              </h4>
              <ul className="space-y-2">
                {categories.map((category, index) => (
                  <li key={index}>
                    <button
                      onClick={() => handleFilterChange(category.name)}
                      className={`w-full text-left px-4 py-2 rounded-md transition-colors flex justify-between items-center ${
                        activeFilter === category.name
                          ? "bg-[#00D084] text-white"
                          : "text-black hover:bg-gray-100"
                      }`}
                    >
                      <span>{category.name}</span>
                      <span className="bg-white text-[#00D084] text-xs font-semibold px-2 py-1 rounded-full">
                        {category.count}
                      </span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Main content - Video posts */}
          <div className="w-full md:w-4/5 lg:w-3/2">
            {filteredVideos.length > 0 ? (
              <>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {filteredVideos.map((post, idx) => (
                    <div key={idx} className="px-2">
                      <div className="bg-gray-100 rounded-2xl shadow p-4 h-[420px] flex flex-col hover:shadow-lg transition duration-300">
                        <div className="relative mb-4 rounded-xl overflow-hidden cursor-pointer">
                          <div
                            onClick={() => post.videoId && openVideoModal(post)}
                          >
                            <img
                              src={post.img}
                              alt={post.title}
                              className="w-full h-40 object-cover"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = Policy;
                              }}
                            />
                            {post.videoId && (
                              <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-black bg-opacity-50 rounded-full p-4">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-12 w-12 text-white"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                                    />
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                  </svg>
                                </div>
                              </div>
                            )}
                          </div>
                          <span className="absolute bottom-2 left-2 bg-[#00D084] text-white px-1 py-1 text-sm font-semibold rounded-full">
                            {post.tag}
                          </span>
                        </div>
                        <h4 className="text-lg font-bold text-gray-900 mb-2 text-center">
                          {post.title}
                        </h4>
                        <p className="text-gray-700 text-md mb-4 text-justify px-2">
                          {truncateWords(post.desc, 20)}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div className="flex justify-center mt-8">
                    <nav className="inline-flex rounded-md shadow">
                      <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                        className={`px-4 py-2 rounded-l-md border ${
                          currentPage === 1
                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                            : "bg-white text-gray-700 hover:bg-gray-50"
                        }`}
                      >
                        Previous
                      </button>
                      {Array.from({ length: totalPages }, (_, index) => (
                        <button
                          key={index}
                          onClick={() => paginate(index + 1)}
                          className={`px-4 py-2 border-t border-b ${
                            currentPage === index + 1
                              ? "bg-[#00D084] text-white"
                              : "bg-white text-gray-700 hover:bg-gray-50"
                          }`}
                        >
                          {index + 1}
                        </button>
                      ))}
                      <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className={`px-4 py-2 rounded-r-md border ${
                          currentPage === totalPages
                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                            : "bg-white text-gray-700 hover:bg-gray-50"
                        }`}
                      >
                        Next
                      </button>
                    </nav>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center py-10">
                <p className="text-gray-500">
                  No videos found in this category.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Videos;
